import React from 'react';

import Pagination from 'features/generic/components/Pagination/Pagination';
import {isEmpty, get} from 'utils/helpers';
import {
    TableCellStyled,
    TableHeaderCell,
    TableHeaderRowStyled,
    TableRowStyled,
} from 'features/generic/components/Table/Table';
import {TileStyled} from 'features/generic/components/Tile/Tile';
import ListFilters from 'features/vip/components/ListFilters/ListFilters';
import Loading from 'features/generic/components/Loading/Loading';

import columns from './columns';

import {VipListOuter, TileStyleCss, ListError, EmptyList} from './styles';

const VipList = (props) => {
    return (
        <VipListOuter>
            <ListFilters {...props} />
            {props.isFetching && <Loading message="Loading..." />}
            {props.error && <ListError>{props.error}</ListError>}
            <TileStyled $css={TileStyleCss}>
                {!isEmpty(props.subscriptions) && (
                    <TableHeaderRowStyled>
                        {columns.map((column, i) => (
                            <TableHeaderCell key={i} flex={column.flex}>
                                <column.HeaderComponent />
                            </TableHeaderCell>
                        ))}
                    </TableHeaderRowStyled>
                )}

                {isEmpty(props.subscriptions) && !props.isFetching && (
                    <EmptyList>No Subscriptions Found</EmptyList>
                )}
                {props.subscriptions.map((subscription) => (
                    <TableRowStyled key={subscription.id}>
                        {columns.map((column, i) => (
                            <TableCellStyled flex={column.flex} key={i}>
                                <column.ChildComponent subscription={subscription} />
                            </TableCellStyled>
                        ))}
                    </TableRowStyled>
                ))}
            </TileStyled>
            <Pagination
                isFetching={props.isFetching}
                total={get(props, 'pagination.total')}
                count={get(props, 'pagination.count')}
                page={get(props, 'pagination.page')}
                handleLoadPage={(page) => props.handleLoadPage(page)}
            />
        </VipListOuter>
    );
};

export default VipList;
